// extracted by mini-css-extract-plugin
export default {"Table":"DefaultListTable_Table__WKsEZ"};